import { TFunction } from 'i18next'
import { FiscalType } from 'src/api/api.generated'

export default function getFiscalTypeDescription(fiscalType: FiscalType, t: TFunction) {
  switch (fiscalType) {
    case FiscalType.CREDIT_NOTE:
      return t('pms.common.document_type.CREDIT_NOTE')
    case FiscalType.INVOICE:
      return t('pms.common.document_type.INVOICE')
    case FiscalType.NON_FISCAL:
      return t('pms.common.document_type.NON_FISCAL')
    case FiscalType.PAID_IN_FULL:
      return t('pms.common.document_type.PAID_IN_FULL')
    case FiscalType.RECEIPT:
      return t('pms.common.document_type.RECEIPT')
    case FiscalType.RETURN_DEPOSIT:
      return t('pms.common.document_type.RETURN_DEPOSIT')
  }
}
